if (!customElements.get('wlsn-buybox-section')) {
    class WLSNBuyboxSection extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                swiper: 'js-wlsn-buybox-section-gallery',
                thumbs: 'js-wlsn-buybox-section-thumbs',
                list: 'swiper-wrapper',
                item: 'swiper-slide',
                stickyCta: 'js-wlsn-buybox-section-sticky-cta',
                disabledStickyClass: 'hide-sticky-cta',
                activeClass: 'is-active'
            };

            this.elements = {
                slider: this.querySelector(`.${this.classes.swiper}`),
                thumbs: this.querySelector(`.${this.classes.thumbs}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                stickyCta: this.querySelector(`.${this.classes.stickyCta}`)
            };

            this.resizeHandler = this.handleResize.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
            window.addEventListener('scroll', this.checkStickyCtaVisibility.bind(this));
            setTimeout(() => {
                this.checkStickyCtaVisibility();
            }, 50);
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy();
            }
            window.removeEventListener('resize', this.resizeHandler);
            if (this.elements.scrollContent) {
                this.removeEventListener('wheel', this.scrollHandler);
            }
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            window.removeEventListener('scroll', this.checkStickyCtaVisibility);
        }

        checkIfEmpty() {
            const listInner = this.elements.list;
            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSwiper();
        }

        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;
            const slidesCount = this.elements.items.length;
    
            if (slidesCount <= 1) return false;
    
            return true;
        }

        handleResize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
    
            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();
    
                if (shouldInit && !this.swiper) {
                    this.initializeSwiper();
                } else if (!shouldInit && this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }
            }, 300);
        }

        initializeSwiper() {
            this.thumbs = new Swiper(this.elements.thumbs, {
                spaceBetween: 8,
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesProgress: true,
                breakpoints: {
                    768: {
                        spaceBetween: 16,
                    }
                }
            });
        
            this.swiper = new Swiper(this.elements.slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                watchOverflow: true,
                centeredSlides: true,
                thumbs: {
                    swiper: this.thumbs,  
                }
            });
        }

        checkStickyCtaVisibility() {
            const stickyBtnEl = this.elements.stickyCta;
            if (!stickyBtnEl) {
                console.warn('Sticky CTA element nije pronađen!', this.elements);
                return; // Ako sticky CTA element ne postoji, izlazi iz funkcije
            }
            
            let visible = false;
            const stickyHideSections = document.querySelectorAll('.hide-sticky-cta');
        
            stickyHideSections.forEach((section) => {
                const rect = section.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    visible = true;
                }
            });
        
            if (visible) {
                stickyBtnEl.classList.remove(this.classes.activeClass);
            } else {
                stickyBtnEl.classList.add(this.classes.activeClass);
            }
        }
        
    }

    customElements.define('wlsn-buybox-section', WLSNBuyboxSection);
}
